<script setup lang="ts">
import ClassLink from './components/ClassLink.vue'
import NewsPin from './components/NewsPin.vue'
import List from './components/List.vue'
import { useArticleStore } from '@/stores'
import useSeo from './seo'

const route = useRoute()
const articleStore = useArticleStore()
await articleStore.fetchArticleCategories('newsCategories', {
  className: 'articleNews'
})
const categories = computed(() => articleStore.getNewsCategories)
const categorySlug = computed(() => route.params.slug)

const currentNewsCategory = categories.value.find((o, i) => o.seo.meta_slug === categorySlug.value || o.id.toString() === categorySlug.value)
articleStore.setCurrentNewsCategory(currentNewsCategory ?? null)

await articleStore.fetchArticleNewsList(currentNewsCategory?.id, parseInt(route.query.page as string || '1'))

const isShow: Ref<boolean> = ref(false)

onMounted(() => {
  isShow.value = true
})

useSeo(currentNewsCategory)
</script>
<template>
  <section class="news" :class="{ isShow: isShow }">
    <div class="news__leftbox">
      <div class="news__leftbox__inner">
        <div class="news__intro">
          <Intro subtitle="news" :data="{
            title: '最新消息'
          }" />
          <ClassLink class="news__classlink" :category-id="currentNewsCategory?.id" />
        </div>
      </div>
    </div>
    <div class="news__rightbox">
      <NewsPin />
      <List />
    </div>
  </section>
</template>
<style lang="scss" scoped>
.news {
  position: relative;
  @include grid;

  @include max-media(960) {
    grid-template-columns: repeat(4, 1fr);
  }

  &__leftbox {
    position: relative;
    grid-column: 1 / span 2;

    &__inner {
      @include min-media(961) {
        position: fixed;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    @include max-media(960) {
      grid-column: 1 / span 4;
      margin-bottom: toRem(32);
    }
  }

  &__rightbox {
    grid-column: 4 / span 8;

    @include max-media(960) {
      grid-column: 1 / span 4;
    }
  }

  &__classlink {
    transform: translateY(30px);
    opacity: 0;
    transition: all 0.5s ease-in-out;
  }

  &.isShow {
    .news {
      &__classlink {
        transform: translateY(0);
        opacity: 1;
        transition-delay: 0.7s;
      }
    }
  }
}
</style>
<style lang="scss">
.news {
  &__intro {
    .intro {
      text-align: right;

      @include max-media(960) {
        text-align: center;
      }

      &__subtitle {
        margin-bottom: toRem(5);
        font-size: toRem(90);

        @include max-media(1430) {
          font-size: 6vw;
        }

        @include max-media(960) {
          font-size: toRem(60);
        }

        letter-spacing: toRem(-2.2);
      }
    }
  }
}
</style>
